<template>
  <!-- Some quando não há o que oferecer — sem nível, ambiente encerrado, nenhuma coleção que aceite.
       Um botão que abre um menu vazio é promessa que não se cumpre. -->
  <v-menu v-if="items.length" location="bottom end">
    <template #activator="{ props }">
      <!-- No xs só o ícone, como a busca ao lado: ali não há largura para a palavra -->
      <v-btn v-if="$vuetify.display.xs" v-bind="props" variant="text" size="small" :icon="icon"
             :aria-label="label"/>
      <v-btn v-else v-bind="props" variant="text" class="shell-trigger shell-plain-case">
        <v-icon start size="small">{{ icon }}</v-icon>
        <span class="shell-value">{{ label }}</span>
      </v-btn>
    </template>
    <v-list density="compact" nav>
      <ontos-menu-items :items="items"/>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import MenuItems, {MenuItem} from '@/components/shell/MenuItems.vue'

/**
 * Um menu da barra do app que leva a outra tela: o "+ Criar" (a página de criar de cada coleção) e o
 * "Design" (a página de design do ambiente e de cada coleção). Ao lado da busca, e pelo mesmo motivo
 * dela: serve a qualquer tela, sem perguntar onde se está.
 *
 * Um componente para os dois porque eram o mesmo controle — o botão de texto da barra que abre uma
 * lista de links —, e o segundo seria a cópia. Os ITENS vêm prontos, e não coleções: o Design tem um
 * que não é coleção, o ambiente. Quem decide quais e para onde é a barra (`App.vue`).
 */
@Component({name: 'ontos-bar-menu', components: {'ontos-menu-items': MenuItems}})
class BarMenu extends Vue {
  @Prop({type: String, required: true}) readonly icon!: string
  @Prop({type: String, required: true}) readonly label!: string
  @Prop({type: Array, required: true}) readonly items!: MenuItem[]
}

export default toNative(BarMenu)
</script>
